// extracted by mini-css-extract-plugin
module.exports = {"pinkAllCapsSubtitle":"_2TXBj"};